<template>
    <v-form ref="form" class="desconto">
        <v-data-table
            :headers="listaHeaderDesconto"
            :items="value.valores"
            :item-class="investimentoClass"
            item-key="nome"
            class="elevation-0 tabela"
            hide-default-footer
            disable-sort
        >
            <template
                v-for="header in listaHeaderDesconto.filter((header) =>
                    header.hasOwnProperty('formatter')
                )"
                v-slot:[`item.${header.value}`]="{ header, value }"
            >
                {{ header.formatter(value) }}
            </template>
            <template v-slot:[`item.valor_total`]="{ item }">
                <vuetify-money
                    v-if="item.mes != 'Total'"
                    :ripple="false"
                    dense
                    outlined
                    hide-details
                    v-model="item.valor_total"
                    class="input-cinza"
                    @input="calculaDesconto()"
                />
            </template>

            <template v-slot:[`item.desconto_total`]="{ item }">
                <vuetify-money
                    v-if="item.mes != 'Total'"
                    :ripple="false"
                    dense
                    outlined
                    hide-details
                    v-model="item.desconto_total"
                    class="input-cinza"
                    @input="calculaDesconto()"
                />
            </template>
            <template v-slot:[`item.investimento_total`]="{ item }">
                <vuetify-money
                    v-if="item.mes != 'Total'"
                    :ripple="false"
                    dense
                    outlined
                    disabled
                    hide-details
                    v-model="item.investimento_total"
                    class="input-cinza"
                />
            </template>
            <template v-slot:[`item.justificativas`]="{ item }">
                <v-text-field
                    placeholder="Justificativa"
                    v-model="item.justificativa"
                    hide-details
                    dense
                    outlined
                    class="input-cinza"
                    :rules="regras.justificativa"
                    :menu-props="menuProps"
                    v-if="
                        ((item.valor_total != '' && item.valor_total != undefined && item.valor_total != 0) ||
                        (item.desconto_total != '' && item.desconto_total != undefined && item.desconto_total != 0)) &&
                        item.mes != 'Total'
                    "
                    required
                ></v-text-field>
            </template>
            <template slot="body.append">
                <tr class="total">
                    <td>Total</td>
                    <td>{{ formataReal(totalCusto) }}</td>
                    <td colspan="2"></td>
                    <td>{{ formataReal(totalInvestimento) }}</td>
                </tr>
            </template>
        </v-data-table>

        <div v-if="dialogoCamposFaltando" class="dialogo-erro" width="700px">
            <v-card class="br-15">
                <v-toolbar
                    elevation="0"
                    dark
                    class="error white--text fix-flex"
                >
                    <v-toolbar-title>
                        Por favor retorne as etapas anteriores e preencha os
                        seguintes campos:</v-toolbar-title
                    >
                </v-toolbar>
                <v-card-text class="pa-5">
                    <v-list>
                        <v-list-item
                            v-for="campo in camposFaltando"
                            :key="campo"
                        >
                            <v-list-item-content>
                                <v-list-item-title>{{
                                    campo
                                }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </div>
        <v-overlay :value="carregando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-overlay
            :value="mostraOverlay"
            :absolute="true"
            :opacity="0.6"
            :z-index="3"
        ></v-overlay>
    </v-form>
</template>
<script>
export default {
    props: ['value'],

    data() {
        return {
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: 'select-outline',
                transition: 'slide-y-transition',
            },
            periodo: null,
            acordo: {},
            valores: [],
            somaFiliais: [],
            somaFiliaisValor: [],
            dialogoCamposFaltando: false,
            desconto: [],
            descontoCampo: {
                percentual: null,
                desconto: null,
            },
            regras: {
                justificativa: [(v) => !!v || 'O campo espaço é obrigatório'],
                valor_rh: [(v) => !!v || 'O campo valor é obrigatório'],
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false /* doesn't work with directive */,
            },
            carregando: false,
            semAcesso: false,
            mesDesconto: [],
            justificativas: [],
            primeiraAlteracao: true,
        }
    },
    watch: {
        'value.mesInicial': function (mes) {
            this.criaDesconto()
        },
        'value.mesFinal': function (mes) {
            this.criaDesconto()
        },
        'value.valores': function (valores) {},
    },
    async created() {
        this.criaDesconto()
    },
    computed: {
        listaHeaderDesconto() {
            const header = [
                {
                    text: 'Mês',
                    value: 'mes',
                    align: 'center',
                    class: 'th-separador',
                    formatter: this.formataMes,
                },
                {
                    text: 'Valor (R$)',
                    value: 'valor_total',
                    align: 'center',
                    class: 'th-separador min-width-100',
                    formatter: this.formataReal,
                },
                {
                    text: 'Desconto (R$)',
                    value: 'desconto_total',
                    align: 'center',
                    class: 'th-separador min-width-100',
                    width: '20%',
                    formatter: this.formataReal,
                },
                {
                    text: 'Justificativa',
                    value: 'justificativas',
                    align: 'center',
                    class: 'th-separador min-width-100',
                    width: '30%',
                },
                {
                    text: 'Investimento (R$)',
                    value: 'investimento_total',
                    align: 'center',
                    class: 'th-separador',
                    formatter: this.formataReal,
                },
            ]

            return header
        },
        totalCusto() {
            if (this.value.valores && this.value.valores.length > 0) {
                return this.value.valores.reduce(
                    (a, b) => a + +b.valor_total,
                    0
                )
            }
            return 0
        },
        totalInvestimento() {
            if (this.value.valores) {
                return this.value.valores.reduce(
                    (a, b) => a + Number(b.investimento_total),
                    0
                )
            }
            return 0
        },

        mostrarPreAcordo() {
            if (this.acordo.idStatus === 30) {
                return true
            }
            const data = this.$moment().format('YYYY-MM')
            if (!this.acordo.idStatus && data !== this.acordo.mesInicial) {
                return true
            }
            return false
        },
        camposFaltando() {
            const campos = []
            return campos
        },
        mostraOverlay() {
            if (this.camposFaltando.length > 0) {
                return true
            }
            return false
        },
    },

    methods: {
        formataReal(valor) {
            return Number(valor).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
            })
        },
        formataMes(mes) {
            if (mes == 'Total') {
                return mes
            }
            return this.$moment(mes, 'YYYY_MM').format('MM/YYYY')
        },
        limpaDesconto() {
            this.$nextTick(() => {
                this.value.valores = []
                this.criaDesconto()
            })
        },

        setSemAcesso(semAcesso) {
            this.semAcesso = semAcesso
        },

        getPeriodo(campo) {
            const inicio = this.$moment(this.value.mesInicial, 'YYYY-MM')
            const fim = this.$moment(this.value.mesFinal, 'YYYY-MM')
            const periodo = []

            let atual = inicio.clone()
            while (atual.isSameOrBefore(fim, 'month')) {
                if (campo) {
                    periodo.push(`${campo}_${atual.format('YYYY-MM-01')}`)
                } else {
                    periodo.push(atual.format('YYYY-MM-01'))
                }
                atual.add(1, 'month')
            }
            return periodo
        },

        async criaDesconto() {
            const periodo = this.getPeriodo()
            // Cria um mapa para acesso rápido aos valores existentes
            const valoresMap = {}
            for (const v of this.value.valores) {
                valoresMap[v.mes] = v
            }

            // Cria novo array apenas com os meses do período, mantendo dados já preenchidos
            const novosValores = periodo.map((mes) => {
                if (valoresMap[mes]) {
                    // Mantém os dados já preenchidos para o mês
                    return valoresMap[mes]
                }
                // Cria novo mês se não existir
                return {
                    mes,
                    valor_total: 0,
                    desconto_total: 0,
                    investimento_total: 0,
                    justificativa: null,
                }
            })

            // Atualiza o array de valores
            this.$set(this.value, 'valores', novosValores)
        },

        calculaDesconto() {
            for (const d of this.value.valores) {
                d.investimento_total = d.valor_total - d.desconto_total
            }
        },
        validate() {
            if (this.value.valores.length == 0) {
                return false
            }

            const validaValores = !this.value.valores.some(
                (v) => v.investimento_total < 0
            )
            const validaCampos = this.$refs.form.validate()

            if (validaValores && validaCampos) {
                return true
            }
            return false
        },
        investimentoClass(item) {
            if (item.mes == 'Total') {
                return ''
            } else {
                return item.investimento < 0
                    ? 'style-investimento-negativo'
                    : ''
            }
        },
    },
}
</script>


<style >
.desconto {
}
.dialogo-erro {
    color: red;
    z-index: 1000;
    position: absolute;
    width: 700px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    margin-top: 100px;
}
</style>